module.exports = __webpack_public_path__ + "static/09-ARABSAU-GAHWA.1091ebfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/09-ARABSAU-GAHWA.png
// module id = 603
// module chunks = 35783957827783